import { render } from "./ReminderPanel.vue?vue&type=template&id=1ed2d9c4"
import script from "./ReminderPanel.vue?vue&type=script&lang=js"
export * from "./ReminderPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__